let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("c9SVX")]).then(() => parcelRequire('7K0Q5'));